import { render, staticRenderFns } from "./SettingsForBroadcast.vue?vue&type=template&id=25dc95b8&scoped=true&"
import script from "./SettingsForBroadcast.vue?vue&type=script&lang=js&"
export * from "./SettingsForBroadcast.vue?vue&type=script&lang=js&"
import style0 from "./SettingsForBroadcast.vue?vue&type=style&index=0&id=25dc95b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25dc95b8",
  null
  
)

export default component.exports